import React from 'react';
import LinkTextFooter from './Refactorizaction/LinkTextFooter';

const FooterLinksTexts = ({ LinkDiscord, LinkInstagram, LinkTelegram }) => (
    <section className="social-media-footer-letter">
        < LinkTextFooter TextContent="Discord"   Link={LinkDiscord}    />
        < LinkTextFooter TextContent="Instagram" Link={LinkInstagram}  />
        < LinkTextFooter TextContent="Telegram"  Link={LinkTelegram}   />
    </section>
)

export default FooterLinksTexts;
